









import { Component, Vue, Prop} from 'vue-property-decorator'
import {handleValueSimplyShow} from '@/views/sheet/widget/valueConfig'
@Component({
  name: 'simpleCell',
  components: {
  }
})
export default class extends Vue {
  @Prop({default: () => ({})}) public item!: any
  @Prop() public value!: any
  private get field () {
    if (this.item.fieldType === 'associationField') {
      return this.item.sourceField
    }
    return this.item
  }
  private get valueShow () {
    return handleValueSimplyShow(this.value, this.item)
  }
}
